import React from 'react';
import {
  Modal,
  Element,
  Color,
  Typography,
  FontType,
  IconButton
} from '@americanexpress/aqx-components';
import styles from './__styles__/index.scss?modules';

const DynamicAppModal = ({ content, modal, toggle, buttonRef }) => {
  return (
    <Modal.Container
      $originHeight={true}
      $isOpen={modal}
      toggle={toggle}
      focusRef={buttonRef}
      ariaLabel="Dialog"
    >
      <Modal.Content
        theme={{
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 20,
          paddingBottom: 20
        }}
      >
        <div className={styles.container}>
          <div className={styles.topBar}>
            <Typography
              $family={FontType.BentonBook}
              className={styles.header}
              $size={30}
              $lineHeight={36}
            >
              {content?.header}
            </Typography>
            <IconButton
              directory="dls"
              onClick={toggle}
              imageName={'dls-icon-close'}
              className={styles.exitButton}
              theme={{
                color: Color.BrightBlue
              }}
              aria-label="Close Modal"
            />
          </div>
          <Typography
            $family={FontType.HelveticaRegular}
            className={styles.subheader}
            $size={16}
            $lineHeight={24}
          >
            {content.subheader}
          </Typography>
          {content.content.map((item, index) => {
            return (
              <div className={styles.description} key={index}>
                <Element
                  className={styles.circleBox}
                  theme={{ bgColor: Color.DeepBlue }}
                >
                  <Typography
                    className={styles.circleText}
                    theme={{ color: Color.White }}
                    $size={20}
                  >
                    {index + 1}
                  </Typography>
                </Element>
                <div className={styles.stepDiv}>
                  <Typography
                    theme={{ color: Color.Gray06 }}
                    $family={FontType.BentonRegular}
                    className={styles.stepHeader}
                  >
                    {item.header}
                  </Typography>
                  <Typography
                    $size={15}
                    theme={{ color: Color.Gray05 }}
                    $family={FontType.HelveticaRegular}
                    $lineHeight={22}
                    className={styles.stepDescription}
                  >
                    {item.description}
                  </Typography>
                </div>
              </div>
            );
          })}
          <Typography
            $size={13}
            theme={{ color: Color.Gray05 }}
            $family={FontType.HelveticaRegular}
            $lineHeight={22}
            className={styles.disclaimer}
          >
            {content.disclaimer}
          </Typography>
        </div>
      </Modal.Content>
    </Modal.Container>
  );
};

export default DynamicAppModal;
